import { Flex, FloraTypography } from '@grupoboticario/flora-react'
import { ClockIcon, CalendarIcon } from '@grupoboticario/flora-react-icons'

import { PREVIEW_LABELS } from '@/constants/eventPreviewLabels'
import { formatDisplayDate, formatDisplayTime } from '@/utils/eventFormatters'

import {
  dateTimeContainerStyle,
  dateTimeLabelStyle,
  dateTimeValueStyle,
  calendarIconStyle,
  clockIconStyle
} from './styles'

const DateTimeDisplay = ({ date, time }) => (
  <Flex css={dateTimeContainerStyle} align="center" gap="$1">
    <CalendarIcon css={calendarIconStyle} size={16} />
    <FloraTypography css={dateTimeLabelStyle} fontSize="bodyLargeStandard" fontWeight="medium">
      {PREVIEW_LABELS.FIELD_DATE}
    </FloraTypography>
    <FloraTypography css={dateTimeValueStyle} fontSize="bodyLargeStandard">
      {formatDisplayDate(date)}
    </FloraTypography>
    <ClockIcon css={clockIconStyle} size={16} />
    <FloraTypography css={dateTimeLabelStyle} fontSize="bodyLargeStandard" fontWeight="medium">
      {PREVIEW_LABELS.FIELD_TIME}
    </FloraTypography>
    <FloraTypography css={dateTimeValueStyle} fontSize="bodyLargeStandard">
      {formatDisplayTime(time)}
    </FloraTypography>
  </Flex>
)

export default DateTimeDisplay
